export const isValidURL = (str?: unknown): boolean => {
  if (typeof str !== "string") return false;
  const regex =
    /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
  return !!regex.test(str);
};
